import dayjs, {Dayjs} from "dayjs";

export interface ErrorResponse {
    status: number;
    message: string;
}

export class Libs {

    static validatePhoneNumber = (phoneNumber: string) => {
        // Regular expression to validate Polish phone numbers (9 digits)
        //const phoneRegex = /^(?:(?:(\+|00)48)|(?:0))?(?:(61|62|63|65|67|68|69|71|74|75|76|77|81|82|83|84|85|86|87|89)[1-9]\d{6}|[1-9]\d{8})$/;
        const phoneRegex =
            /^(?:(?:(\+|00)48)|(?:0))?\s?(?:(61|62|63|65|67|68|69|71|74|75|76|77|81|82|83|84|85|86|87|89))?\s?[1-9]\d{2}\s?\d{3}\s?\d{3}$/;
        return phoneRegex.test(phoneNumber);
    };

    static validateEmail = (email : string) => {
        // Regular expression to validate email addresses
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        return emailRegex.test(email);
    };

    static handleError(error: any) : ErrorResponse
    {
        let ret = {
            status: 0,
            message: "Nieznany błąd",
        };
        if (!error) {
            return ret;
        }

        console.error('[Error]:', error);

        if(error.response) {
            if (error.response.data && !Array.isArray(error.response.data)) {
                ret.message = error.response.data;
            }
            if (error.response.status) {
                ret.status = error.response.status;
            }
        } else {
            if (error.status) {
                ret.status = error.status;
            }
            if (error.message) {
                ret.message = error.message;
            }
        }

        return ret;
    }

    static minuteConverter = (minutes: any) => {
        if(!minutes)
            return "Brak darmowych minut";

        const BRAK_DARMOWYCH = 0;
        const BEZ_OGRANICZEN = 44640;
        const parsedValue = parseInt(minutes, 10);

        if (0 < parsedValue && parsedValue < BEZ_OGRANICZEN) {
            return minutes + " darmowych minut";
        }

        if (BRAK_DARMOWYCH === parsedValue) {
            return "Brak darmowych minut";
        }

        if (parsedValue < 0 || BEZ_OGRANICZEN <= parsedValue) {
            return "Minuty bez ograniczeń";
        }

        return parsedValue + " darmowych minut";
    };

    static monthEarlier(monthsBack: number) : Dayjs {
        return dayjs().subtract(monthsBack, 'month').startOf('month');
    };
}
